<div class="padding" [ngClass]="{'px-container': !evidenza}">
    <section *ngIf="!evidenza" [class]="titolo_padding">    

        <div class="titolo flex flex-row justify-between items-center">
            <!-- TITOLO -->
            <h1 class="lg:text-4xl text-2xl" *ngIf="titolo.length > 0">{{titolo}}</h1>
            <!-- LINK -->
                <a class="cta-link" *ngIf="titolo_button" [routerLink]="titolo_button_link">{{titolo_button_text}}</a>
            <!-- TITOLO CON LINK -->            
        </div>    
    </section>


    <section class="relative" [ngClass]="{'lg:pt-0 pt-24': evidenza}">
        <!-- SLIDER -->
        <swiper-container #swiper [loop]="loop" [navigation]="{prevEl: undefined, nextEl: undefined}" [speed]="1000" 
            [navigation]="false" [slidesPerView]="slidesPerView" [grabCursor]="grabCursor" [spaceBetween]="spaceBetween" [breakpoints]="breakpoints">
            <ng-content></ng-content>
        </swiper-container>
        <!-- SLIDER -->
        
        <!-- NAVIGAZIONE EVIDENZA -->
        <div class="absolute right-[5%] top-0 lg:top-[50%] translate-y-[65%] lg:translate-y-[-50%] z-[40]" *ngIf="evidenza">
            <div class="flex w-full justify-end">
                <button class="bg-accent p-6 button-slider border-r border-white prev" (click)="onPrev()" [disabled]="index === slides"></button>
                <button class="bg-accent p-6 button-slider next" (click)="onNext()" [disabled]="index >= sliderLength"></button>
            </div>
        </div>
        <!-- NAVIGAZIONE EVIDENZA -->        
    
        <!-- NAVIGAZIONE -->
        <div class="flex justify-end pt-16 h-full" *ngIf="!evidenza && navigation">
            <button class="bg-accent p-6 button-slider border-r border-white prev" (click)="onPrev()" [disabled]="index === slides"></button>
            <button class="bg-accent p-6 button-slider next" (click)="onNext()" [disabled]="index >= sliderLength"></button>
        </div>
        <!-- NAVIGAZIONE -->
    </section>

</div>